import type { FC } from 'react';
import {
  BiData,
  BiContextProvidedValue,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import CreateTierCard from '../../_partials/CreateTierCard';
import TierCard from '../../_partials/TierCard';
import { Props, THUMB_WIDTH, MAX_TIERS } from './TierListDesktop';

import s from './TierListMobile.scss';

const THUMB_GAP = 16;
const THUMB_HEIGHT = 95;

// Wrapper to decouple the measure hook from the desktop version
const TierListMobile: FC<Props> = ({
  tiers,
}) => {
  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.STASH_FOLDER_CARD,
    { cookieDim: 'width' }
  );

  const thumbWidth = measuredContainer?.width
    ? (measuredContainer.width - THUMB_GAP) / 2
    : THUMB_WIDTH;

  if (!(tiers && tiers.length > 0)) {
    return null;
  }

  return (
    <BiLoggerContextProvider value={{ sectionname: 'tiers' }}>
      <div className={s['root']} ref={ref}>
        <div className={s['expanded-grid']}>
          {tiers.length < MAX_TIERS && (
            <CreateTierCard
              width={thumbWidth}
              height={THUMB_HEIGHT}
              hasTiers
            />
          )}
          {tiers.map(tier => (
            <TierCard
              key={`tier-${tier.deviationId}`}
              className={s['card']}
              tier={tier}
              width={thumbWidth}
              height={THUMB_HEIGHT}
              biData={BiData<ItemClickBiEvent>({
                evid: 100,
                view: BiContextProvidedValue,
                component: BiContextProvidedValue,
                page_typeid: BiContextProvidedValue,
                page_itemid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                typeid: ResourceType.TIER,
                itemid: tier.deviationId,
              })}
            />
          ))}
        </div>
      </div>
    </BiLoggerContextProvider>
  );
};
TierListMobile.displayName = 'TierListMobile';

export default TierListMobile;
